export function filterEmptyFields(data) {
  return Object.fromEntries(
    Object.entries(data).filter(([key, value]) => {
      // Verifica se o valor não é uma string vazia e não é um array vazio
      return !(value === "" || (Array.isArray(value) && value.length === 0));
    })
  );
}
